export default __webpack_public_path__ + "static/logo-dpr-bad5dce80352aa139009c3ccd78ee334.png";